var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-card",
    { attrs: { title: _vm.titlePage } },
    [
      _c("FormBasicInfo", { ref: "formBasic" }),
      _c("section", { staticClass: "mt-3" }, [_c("FormProductSupplier")], 1),
      _c(
        "section",
        { staticClass: "mt-3" },
        [_c("FormProductAccount", { ref: "formAccount" })],
        1
      ),
      _c("section", { staticClass: "mt-3" }, [_c("FormUomConversion")], 1),
      _c("a-divider"),
      _c(
        "div",
        { staticClass: "mt-2 text-right" },
        [
          _c(
            "a-space",
            [
              _c("a-button", { on: { click: _vm.handleBack } }, [
                _vm._v(" " + _vm._s(_vm.$t("lbl_back")) + " ")
              ]),
              _vm.$can("update", "product") || _vm.$can("create", "product")
                ? _c(
                    "a-button",
                    {
                      attrs: { type: "primary", loading: _vm.loading },
                      on: { click: _vm.handleSave }
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("lbl_save")) + " ")]
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }